// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

// Components
import Text from "@Components/Text";
import ImageContent from "../ImageContent";

// Styles
import styles from "./styles.module.css";

const NoteContent = ({ item }) => {
	if (!isEmpty(item.uri)) {
		return <ImageContent item={item} />;
	}

	if (isEmpty(item.text)) {
		return <Text className={styles.text}>Nota</Text>;
	}

	return (
		<Text className={styles.text} withMarkdown>
			{item.text}
		</Text>
	);
};

NoteContent.propTypes = {
	item: PropTypes.object,
};

export default NoteContent;
